// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"380":"650aa579","714":"46f3c6e0","763":"97e30138","784":"de849a79","808":"c49942c9"}[chunkId] + ".chunk.js";
};